import React, { useCallback, useEffect, useState } from 'react'
import {Button, Col, Form, Row, Spinner, Toast, ToastContainer} from 'react-bootstrap'
import {KTSVG} from '../../../../_metronic/helpers'
import Select from 'react-select'
import {useDropzone} from 'react-dropzone'
// import CustomCkEditor from '../../ckeditor/CustomCkEditor'
import JoditEditor from 'jodit-react';
import { useFormik } from 'formik'
import { createArticleApi, downloadMediaApi, editArticleApi, getGradeList, updateArticleApi, uploadMedia } from './articles-list/core/_requests'
import { getCate } from '../news-category/cates-list/core/_requests'
import { useParams, useNavigate } from 'react-router-dom'
import moment from 'moment'
import { useIntl } from 'react-intl'

const editorConfig = {
  height: 400,
  toolbar: true,
  readonly: false,
  placeholder: 'Enter news content...',
  buttons: [
    'bold', 'italic', 'underline', '|',
    'ul', 'ol', '|',
    'link', 'image', 'video', '|',
    'undo', 'redo',
  ],
  autofocus: false,
  cleanHTML: {
    fillEmptyParagraph: false,
    removeEmptyElements: false
  },
};

const AddEditNewsArticle = ({isEditing}:any) => {
  const navigate = useNavigate()
  const [file, setFile] = useState<any>()
  const [fileName, setFileName] = useState<any>()
  const [isLoading,setIsLoading] = useState<any>(false)
  const [categoryList,setCategoryList] = useState<any>([])
  const [gradeGroupList,setGradeGroupList] = useState<any>([])
  const {id} = useParams()
  const [loadCKEditor,setLoadCKEditor] = useState<any>(true)
  const [editorContent, setEditorContent] = useState('');
  const [loadEditor, setLoadEditor] = useState<any>(true);
  const [btnLoading,setBTNLoading] = useState<any>(false)
  const [createdDatePart, setCreatedDatePart] = useState('')
  const [createdTimePart, setCreatedTimePart] = useState('')
  const [createdAmPmPart, setCreatedAmPmPart] = useState('')
  const intl = useIntl()
  const onDrop = useCallback((acceptedFiles: any) => {
    acceptedFiles.forEach((file: any) => {
      const reader = new FileReader();
  
      reader.onload = (event: any) => {
        const img = new Image();
        img.src = event.target.result;
  
        img.onload = () => {
          // Validate image dimensions
          if (img.width !== 1000 || img.height !== 1000) {
            setSessionMessage({
              type: 'danger',
              message: intl.formatMessage({ id: 'PLEASE.UPLOAD.AN.IMAGE.OF.1000*1000.PIXELS' }),
              show: true,
            });
            return;
          }
  
          // Proceed to upload if dimensions are valid
          setFile(file);
          uploadArticleImageApi(file);
        };
      };
  
      reader.onerror = () => {};
  
      reader.onabort = () => {};
  
      reader.readAsDataURL(file);
    });
  }, []);

  const {getRootProps, getInputProps, open, acceptedFiles} = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop,
    accept: {
      'image/png': ['.png','.jpg'],
    }
  })

  const [sessionMessage, setSessionMessage] = useState({
    type: '',
    message: '',
    show: false,
  })

  const validate = (values:any) => {
    const errors = {} as any;
    if (!values.title) {
      errors.title = 'This title field is required';
    }
    if (!values.category) {
      errors.category = 'This category field is required';
    }
    if (!values.content) {
      errors.content = 'This content field is required';
    }
    // if (!values.created_at) {
    //   errors.created_at = 'This date field is required';
    // }
    return errors;
  };

  const formik = useFormik({
    validate,
    validateOnChange:false,
    initialValues: {
      title: '',
      category: '',
      grade_group_names: [],
      content: '',
      image:'',
      created_at:'',
    },
    onSubmit: (values:any) => {
      addEditArticleApi(values)
    }
  }) as any;

  const setCategoryListState = async () => {
    let response = await getCate(`perPage=1000&page=1`)
    if(response.responseStatus == 200){
      let data = response?.data || []
      let newData = data.map((x:any,i:any)=>{
        x.label = x.name
        x.value = x.id
        return x
      })
      setCategoryList(newData)
    }
  }

  const addEditArticleApi = async (data:any) => {
    setBTNLoading(true)
    try{
      let formData = {
        title: data.title,
        category_id: data.category,
        grade_group_names: data.grade_group_names,
        content: data.content,
        image_name: fileName ?? "",
        created_at: data?.created_at,
      }
      if(isEditing){
        var response = await updateArticleApi(id,formData)
      }
      else{
        var response = await createArticleApi(formData)
      }
      if(response.responseStatus == 200){
        setSessionMessage({type: 'success',message: response.responseMessage ,show: true})
        setTimeout(()=>{navigate('/news-articles/articles')},1500)
      }
      else{
        setSessionMessage({type: 'danger',message: response.responseMessage ,show: true})
      }
      setBTNLoading(false)
    }
    catch(err){
      setSessionMessage({type: 'danger',message: "Something Went Wrong" ,show: true})
      setBTNLoading(false)
    }
  }

  const getArticleApi = async () => {
    setIsLoading(true)
    // setLoadCKEditor(true)
    setLoadEditor(true);
    try{
      var response = await editArticleApi(id)
      if(response?.responseStatus == 200){
        let data = response?.responseData ?? {}
        formik.setFieldValue("title",data.title)
        formik.setFieldValue("content",data.content)
        formik.setFieldValue("category",data.category_id)
        formik.setFieldValue("grade_group_names",Array.isArray(data.grade_group_names) ? data.grade_group_names : [])
        formik.setFieldValue("created_at",data.created_at)
        const createdParts = parseCreatedDateTime(data.created_at)
        setCreatedDatePart(createdParts.date)
        setCreatedTimePart(createdParts.time)
        setCreatedAmPmPart(createdParts.ampm)
        setFileName(data.image_name)
      }
      else{
        setSessionMessage({type: 'danger',message: response.responseMessage ,show: true})
      }
      setIsLoading(false)
      setTimeout(()=>{
        // setLoadCKEditor(false)
        setLoadEditor(false);
      },2000)
    }
    catch(err){
      setSessionMessage({type: 'danger',message: "Something Went Wrong" ,show: true})
      setIsLoading(false)
      // setLoadCKEditor(false)
      setLoadEditor(false);
    }
  }

  const uploadArticleImageApi = async (file:any) => {
    setIsLoading(true)
    try{
      let formData = new FormData()
      formData.append("news",file)
      var response = await uploadMedia(formData)
      if(response.newFilename != ""){
        setFileName(response.newFilename)
        setSessionMessage({type: 'success',message: "Image Upload Successfully" ,show: true})
      }
      else{
        setSessionMessage({type: 'danger',message: "Something Went Wrong" ,show: true})
      }
      setIsLoading(false)
    }
    catch(err){
      setSessionMessage({type: 'danger',message: "Something Went Wrong" ,show: true})
      setIsLoading(false)
    }
  }

  const files = acceptedFiles.map((file: any) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ))

  useEffect(()=>{
    if(id){
      getArticleApi()
    }else{
      // setLoadCKEditor(false)
      setLoadEditor(false);
      // Add mode: prefill Date & Time with the current date and time
      const nowParts = parseCreatedDateTime(new Date())
      setCreatedDatePart(nowParts.date)
      setCreatedTimePart(nowParts.time)
      setCreatedAmPmPart(nowParts.ampm)
      formik.setFieldValue('created_at', combineCreatedDateTime(nowParts))
    }
  },[id])

  useEffect(()=>{
    setTimeout(()=>{
      setSessionMessage({type: '',message: '',show: false})
    },5000)
  },[sessionMessage.show])

  useEffect(()=>{
    setCategoryListState()
    getGradeList().then((response) => {
      const data = response?.data || []
      setGradeGroupList(data.map((item: any) => ({...item, label: item.name, value: item.name})))
    })
  },[])
  useEffect(() => {
  setEditorContent(formik.values.content || '');
}, [formik.values.content]);

  // Splits a stored created_at value into date + 12hr time ('00:00'-'12:30' in 30-min steps)
  // + AM/PM for the Date & Time picker, same as the inquiry form.
  const parseCreatedDateTime = (value: any) => {
    if (!value) return {date: '', time: '', ampm: ''}
    const dt = moment(new Date(value))
    if (!dt.isValid()) return {date: '', time: '', ampm: ''}
    const hh = dt.hours()
    const ampm = hh < 12 ? 'AM' : 'PM'
    let hour = hh % 12
    if (hour === 0) hour = 12
    const minute = dt.minutes() >= 30 ? '30' : '00'
    return {date: dt.format('YYYY-MM-DD'), time: `${String(hour).padStart(2, '0')}:${minute}`, ampm}
  }

  // Date only (no time selected) keeps the existing date-only behaviour.
  const combineCreatedDateTime = ({date, time, ampm}: {date: string; time: string; ampm: string}) => {
    if (!date) return ''
    if (!time || !ampm) return date
    const [hour, minute] = time.split(':')
    let hour24 = parseInt(hour, 10) % 12
    if (ampm === 'PM') hour24 += 12
    return moment(`${date}T${String(hour24).padStart(2, '0')}:${minute}`, 'YYYY-MM-DDTHH:mm').format()
  }

  const createdTimeOptions = Array.from({length: 13}, (_, i) => i).flatMap((h) =>
    ['00', '30'].map((m) => `${String(h).padStart(2, '0')}:${m}`)
  )
  const createdAmPmOptions = ['AM', 'PM']

  const handleEditorBlur = useCallback((newContent: string) => {
    formik.setFieldValue('content', newContent);
  }, [formik]);

  return (
    <>
      <Col xl={6} className='ms-auto me-auto'>
        <Form className='p-5' id='kt_modal_add_user_form' onSubmit={formik.handleSubmit}>
          {isLoading ?
          <div
            style={{
              height: '550px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner animation='border' />
          </div>
          : <>
            <Col className='mb-7'>
              <Col>
                <Col className='mb-8'>
                  <Form.Group>
                    <Form.Label className='required fw-bold fs-6 mb-1 form-label'>Title</Form.Label>
                    <Form.Control
                      type='text'
                      className='form-control form-control-solid mb-lg-0'
                      placeholder='Title'
                      onChange={(e:any)=>{
                        formik.setFieldValue("title",e.target.value)
                      }}
                      value={formik.values.title}
                    />
                    <span className='text-danger'>{formik.errors?.title}</span>
                  </Form.Group>
                </Col>
                <Col className='mb-8'>
                  <Form.Group>
                    <Form.Label className='fw-bold fs-6 mb-1 form-label'>Date & Time</Form.Label>
                    <div className='d-flex gap-4'>
                      <Form.Control
                        type='Date'
                        className='form-control-solid flex-fill'
                        placeholder='Select Date'
                        value={createdDatePart}
                        onChange={(e: any) => {
                          setCreatedDatePart(e.target.value)
                          formik.setFieldValue(
                            'created_at',
                            combineCreatedDateTime({
                              date: e.target.value,
                              time: createdTimePart,
                              ampm: createdAmPmPart,
                            })
                          )
                        }}
                      />
                      <Form.Select
                        className='form-select form-select-solid flex-fill'
                        value={createdTimePart}
                        onChange={(e: any) => {
                          setCreatedTimePart(e.target.value)
                          formik.setFieldValue(
                            'created_at',
                            combineCreatedDateTime({
                              date: createdDatePart,
                              time: e.target.value,
                              ampm: createdAmPmPart,
                            })
                          )
                        }}
                      >
                        <option value=''>Select Time</option>
                        {createdTimeOptions.map((t) => (
                          <option key={t} value={t}>
                            {t}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Select
                        className='form-select form-select-solid flex-fill'
                        value={createdAmPmPart}
                        onChange={(e: any) => {
                          setCreatedAmPmPart(e.target.value)
                          formik.setFieldValue(
                            'created_at',
                            combineCreatedDateTime({
                              date: createdDatePart,
                              time: createdTimePart,
                              ampm: e.target.value,
                            })
                          )
                        }}
                      >
                        <option value=''>AM/PM</option>
                        {createdAmPmOptions.map((p) => (
                          <option key={p} value={p}>
                            {p}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                    {/* <span className='text-danger'>{formik.errors?.created_at}</span> */}
                  </Form.Group>  
                </Col>  
                {fileName && 
                <Col className='mb-8'>
                  <Col className='text-start'>
                    <img src={downloadMediaApi(fileName)} width={150} height={150}></img>
                  </Col>
                </Col>}
                <Col className='mb-8'>
                  <Col className='text-start'>
                    <Form.Label className='form-label text'>Here Image Selection</Form.Label>
                    <div onClick={open}>
                      <div {...getRootProps({className: 'dropzone py-12'})}>
                        <input {...getInputProps()} />
                        <div className='dz-message needsclick'>
                          <span className='svg-icon svg-icon-3hx svg-icon-primary'>
                            <KTSVG
                              path='/media/icons/duotune/files/fil009.svg'
                              className='svg-icon-muted svg-icon-2hx'
                            />
                          </span>
                          <div className='ms-4'>
                            <h3 className='fs-5 fw-bold text-gray-900 pt-5'>
                              Drag/Drop files here or click here
                            </h3>
                            {/* <span className='fw-semibold fs-4 text-muted'>Upload files</span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Col>
                <Col className='mb-7'>
                  <Form.Group>
                    <Form.Label className='required fw-bold fs-6 mb-1 form-label'>
                      Select Category
                    </Form.Label>
                    <Select
                      options={categoryList}
                      className='custom_select mb-3'
                      classNamePrefix='Select'
                      placeholder='Select Category'
                      onChange={(e:any)=>{
                        formik.setFieldValue("category",e.value)
                      }}
                      value={categoryList.find((x:any)=>x.value==formik.values.category)}
                    />
                    <span className='text-danger'>{formik.errors?.category}</span>
                  </Form.Group>
                </Col>
                <Col className='mb-7'>
                  <Form.Group>
                    <Form.Label className='fw-bold fs-6 mb-1 form-label'>
                      Select Grade Groups
                    </Form.Label>
                    <Select
                      isMulti
                      options={gradeGroupList}
                      className='custom_select mb-3'
                      classNamePrefix='Select'
                      placeholder='Select Grade Groups'
                      onChange={(options: readonly any[]) => {
                        formik.setFieldValue('grade_group_names', (options || []).map((option: any) => option.value))
                      }}
                      value={gradeGroupList.filter((option: any) => formik.values.grade_group_names?.includes(option.value))}
                    />
                  </Form.Group>
                </Col>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label className='required fw-bold fs-6 mb-1 form-label'>
                    News Content
                  </Form.Label>
                  {
                    loadEditor ? 
                    <div className='text-center px-5' style={{fontSize:'17px',fontWeight:'450'}}>Loading...</div> :
                  <JoditEditor
                    value={formik.values.content}
                    config={editorConfig}
                    onBlur={handleEditorBlur}
                  />
                  }
                  {/* {JSON.stringify(formik.values)} */}
                  <span className='text-danger'>{formik?.errors?.content as any}</span>
                  {/* <CKEditor initData="" /> */}
                  {/* <Form.Control type='text' className='form-control form-control-solid mb-lg-0' rows={5} as="textarea" placeholder="News Content" /> */}
                </Form.Group>
              </Col>
            </Col>

            <Row className='mb-7'>
              <Col className='text-end'>
                <Form.Group>
                  <Button
                    type='submit'
                    className='btn btn-primary font-weight-bold me-3 fs-5 btn-block'
                    data-kt-users-modal-action='submit'
                    disabled={isLoading || btnLoading}
                  >
                    <span className='indicator-label'>{btnLoading ? "Please Wait..." : isEditing ? "Edit" : "Add"}</span>
                  </Button>

                  <Button
                    type='reset'
                    className='btn btn-light-primary fs-5 '
                    data-kt-users-modal-action='cancel'
                    onClick={()=>{
                      navigate('/news-articles/articles')
                    }}
                  >
                    Cancel
                  </Button>
                </Form.Group>
              </Col>
            </Row>
          </>
          }
        </Form>
        <ToastContainer className='p-3 position-fixed' position={'top-center'}>
          <Toast
            show={sessionMessage.show}
            bg={sessionMessage.type}
          >
            <Toast.Body className='text-white'>{sessionMessage.message}</Toast.Body>
          </Toast>
        </ToastContainer>
      </Col>
    </>
  )
}
export default AddEditNewsArticle
